import React from 'react'
import RouterHook from '../../contexts/RouterHook'
import MobileAuth from '../../components/Simple/Auth/MobileAuth'
import VerificaEmail from '../../components/Forms/Auth/VerificaEmail'
import VerificaCodigo from '../../components/Forms/Auth/VerificaCodigo'
import { AuthContext } from '../../contexts/AuthContext'
import UserInfoStep from '../../components/Forms/Cadastro/UserInfo'

/* eslint-disable react-hooks/exhaustive-deps */
export default function MobileLogin() {
  const serverRouter = RouterHook()
  const { uiControls, actionsAuth } = React.useContext(AuthContext)

  function ReturnSttPage() {
    if (uiControls.step === 'login') {
      return serverRouter('back')
    } else if (uiControls.step === 'verifEmail') {
      return actionsAuth.authStep('login')
    } else if (uiControls.step === 'codVerif') {
      return actionsAuth.authStep('verifEmail')
    } else if (uiControls.step === 'cadastro') {
      return actionsAuth.authStep('cadastro')
    }
  }

  React.useEffect(() => {
    document.title = 'Entrar | Agendei Quadras'
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', ReturnSttPage)
    return () => {
      window.removeEventListener('popstate', ReturnSttPage)
    }
  }, [uiControls.step])

  return (
    <div className='contain-mobile-login'>
      {/* {uiControls.step !== 'login' && <LinearProgress variant='determinate' value={calculateProgress} sx={{ height: 5, width: '100%' }} />} */}
      {uiControls.step === 'login' ? (
        <MobileAuth />
      ) : uiControls.step === 'verifEmail' ? (
        <VerificaEmail />
      ) : uiControls.step === 'codVerif' ? (
        <VerificaCodigo />
      ) : (
        uiControls.step === 'cadastro' && <UserInfoStep />
      )}
    </div>
  )
}
